import './App.css'

import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'
import React, { Component } from 'react'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'

import ChatIframePage from './containers/ChatIframePage'
import Analytics from './components/Analytics'
import ChatPage from './containers/ChatPage'
import AdminChatPage from './containers/AdminChatPage'
import TrackPage from './containers/TrackPage'
import ScrollToTop from './components/ScrollToTop'
import PresentationDetailPage from './containers/PresentationDetail/PresentationDetailPage'
import ProgramPage from './containers/ProgramPage'
import VenuePage from './containers/VenuePage'
import AppTemplate from './components/AppTemplate'
import AboutPage from './containers/AboutPage'
import SponsorsPage from './containers/SponsorsPage'
import ReportProblemPage from './containers/ReportProblemPage'
import { muiTheme } from './app/theme'
import ExhibitorsPage from './containers/ExhibitorsPage'

class App extends Component {
  render() {
    return (
      <Router>
        <MuiThemeProvider muiTheme={muiTheme}>
          <ScrollToTop excluded={['/', '/track/:id']}>
            <Analytics />
            <Switch>
              <Route path="/admin/chat/:key" component={AdminChatPage} />
              <Route
                path="/iframe/chat/:appId/:roomId/:mode/:token?"
                component={ChatIframePage}
              />
              <Route path="/">
                <AppTemplate>
                  <Route exact path="/" component={ProgramPage} />
                  <Route path="/venue" component={VenuePage} />
                  <Route path="/about" component={AboutPage} />
                  <Route path="/sponsors" component={SponsorsPage} />
                  <Route path="/exhibitors" component={ExhibitorsPage} />
                  <Route path="/chat" component={ChatPage} />
                  <Route path="/track/:id" component={TrackPage} />
                  <Route
                    path="/presentation/:id"
                    component={PresentationDetailPage}
                  />
                  <Route path="/report" component={ReportProblemPage} />
                </AppTemplate>
              </Route>
            </Switch>
          </ScrollToTop>
        </MuiThemeProvider>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js